module.exports = __webpack_public_path__ + "img/背景@2x.c265437f.png";